import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import { Modal as InstModal } from '@instructure/ui-modal';
import { InstUISettingsProvider } from '@instructure/emotion';
import liveRegion from '../../alertHelpers';

// NOTE: This component should not be used if there is a Select component on the Modal
// because it hides the dropdown. On the other hand it is rendered in front of the
// Learnosity calculator. The edge case when a Modal contains Select and needs to be
// rendered in front of the calculator is not solved at the moment.
// However it's an easy task with emotion.js that is used in InstUI v8.
export var ImportantModal = /*#__PURE__*/function (_Component) {
  function ImportantModal() {
    _classCallCheck(this, ImportantModal);
    return _callSuper(this, ImportantModal, arguments);
  }
  _inherits(ImportantModal, _Component);
  return _createClass(ImportantModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(InstUISettingsProvider, {
        theme: {
          // make this type of Modal appear in front of the learnosity calculator
          componentOverrides: {
            Mask: {
              zIndex: 10000 // defaults to 9999
            }
          }
        }
      }, /*#__PURE__*/React.createElement(InstModal, Object.assign({
        liveRegion: liveRegion
      }, this.props)));
    }
  }]);
}(Component);
export default ImportantModal;